export enum SituacaoCompra {
    EmCriacao = 1, 
    Criado = 2, 
    ProcessamentoIniciado = 3,
    ParcialmenteProcessado = 4,
    ProcessadoComSucesso = 5,
    NaoProcessado = 6,
    Cancelado = 7,
    Rascunho = 8,
}
